import { CategoryInterface, MediaFile, ServiceInterface } from "./common.types";

export interface UserInterface extends ShorUserInterface {
  email: string;
  description: string | null;
  website: string | null;
  isSocialMediaAccount: boolean;
  type: UserTypes;
  status: UserStatuses;
  isVerified: boolean;
  lastActivity: string;
  profilePicture: string;
  legalAgreements: {
    termsAndConditions: boolean;
    privacyPolicy: boolean;
  };
  location: {
    latitude: number;
    longitude: number;
    country: { id: number; name: string };
    county: {
      id: number;
      name: string;
      code: string;
    };
    city: {
      id: number;
      name: string;
    };
    addressDetails: string
  };
  categories: CategoryInterface[];
  services: ServiceInterface[];
  notifications: {
    notifiedOnNewComments: boolean;
    notifiedOnNewPosts: boolean;
    notifiedOnNewMessages: boolean;
  };
  company: Company;
  deletedAt: string | null;
}

export interface ShorUserInterface {
  id: number;
  firstName: string;
  lastName: string;
  profilePicture: string;
  // Company (JURIDICAL) accounts surface under their company name. These
  // are optional because the slim comment/chat payloads only started
  // carrying them once the backend was updated; older responses omit them.
  type?: UserTypes;
  company?: { id: number; name: string; logo?: string | null } | null;
}

export interface Company {
  id: number;
  name: string;
  description: string;
  logo: string;
  mediaFiles: MediaFile[];
  registration_number: string;
  CUI: string;
}

export enum UserTypes {
  PHYSICAL = 1,
  JURIDICAL = 2,
}

export enum UserStatuses {
  PENDING = 1,
  ACTIVE = 2,
  INACTIVE = 3,
  BLOCKED = 4,
}

export interface UserStats {
  freePosts: number;
  paidPosts: number;
  transactions: number;
  reports: number;
  /** Profile analytics over the last 30 days — feature #9 mirror.
   *  Optional because legacy backend builds may not return them. */
  profileVisits30d?: number;
  profileUniqueVisitors30d?: number;
  profileAvgDwellSeconds30d?: number;
  /** -1.0 ... +∞. Positive = growth vs the prior 7-day window. */
  profileWeekOverWeekDelta?: number;
}
